import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dd30093"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigame-prize" }
const _hoisted_2 = { class: "t-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-prize-title" }, "奖项设置", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-prize-subtitle" }, "大赛共计5个赛道，每个赛道设置：", -1))
const _hoisted_5 = { class: "aigame-prize-list" }
const _hoisted_6 = { class: "aigame-prize-item__title" }
const _hoisted_7 = { class: "aigame-prize-item__subtitle" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-area-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "aigame-prize-item__title" }, "参赛福利："),
  /*#__PURE__*/_createElementVNode("div", null, "1.所有报名并成功提交作品的选手均可获得腾讯专属公仔1个"),
  /*#__PURE__*/_createElementVNode("div", null, "2.获奖队伍可获得腾讯集团校招/实习直面绿色通道"),
  /*#__PURE__*/_createElementVNode("div", { class: "aigame-area-tips" }, "*（上述奖项以决赛的最终名次决定）")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prizeItem, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "aigame-prize-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.subTitle), 1),
              _createElementVNode("img", {
                src: item.src,
                alt: "",
                class: "aigame-prize-item__img"
              }, null, 8, _hoisted_8)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_9
  ]))
}